/* eslint-disable no-unused-vars */
import { Button, CircularProgress, Typography } from "@mui/material";
import PCheck from "../../components/pos/PCheck";
import PSettingsCard from "../../components/pos/PSettingsCard.jsx";
import PText from "../../components/pos/PText";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import API from "../../utils/API";

export default function SuperAdminApi(props) {
  const { t } = useTranslation();
  const translate = t;
  const [liveValidation, setLiveValidation] = useState(false);

  const [cloudPrinterUrl, setCloudPrinterUrl] = useState("");
  const [cloudPrinterApiKey, setCloudPrinterApiKey] = useState("");
  const [testingInprogress, setTestingInprogress] = useState(false);

  async function testApi() {
    setTestingInprogress(true);
    try {
      await API.post("/api/v1/cloudprint/test", {
        url: cloudPrinterUrl,
        apiKey: cloudPrinterApiKey,
      });
      props.messagHandler("success", "API integration is successful");
    } catch (err) {
      console.log(err);
      props.messagHandler(
        "error",
        "Not able Integrate with cloud print service"
      );
    }
    setTestingInprogress(false);
  }

  const content = (
    <table width="100%">
      <tbody>
        <tr>
          <td style={{ width: "300px" }}>
            <Typography variant="body1">
              {translate("Cloud Printer URL")}
            </Typography>
          </td>
          <td>
            <PText
              type={"text"}
              value={cloudPrinterUrl}
              onChange={(e) => setCloudPrinterUrl(e.target.value)}
            ></PText>
          </td>
        </tr>
        <tr>
          <td>
            <Typography variant="body1">
              {translate("Cloud Printer API Key")}
            </Typography>
          </td>
          <td>
            <PText
              type={"text"}
              value={cloudPrinterApiKey}
              maxRows={7}
              rows={7}
              multiline={true}
              onChange={(e) => setCloudPrinterApiKey(e.target.value)}
            ></PText>
          </td>
        </tr>
        <tr>
          <td></td>
          <td>
            <Button
              onClick={testApi}
              variant="contained"
              color="primary"
              disabled={testingInprogress}
            >
              {testingInprogress && <CircularProgress size={20} />}Test API
            </Button>
          </td>
        </tr>
      </tbody>
    </table>
  );

  function validate() {
    setLiveValidation(true);
    return true;
  }

  function validateItemCodeLen() {}

  function createPayload(payload) {
    payload["cloudPrinterUrl"] = cloudPrinterUrl;
    payload["cloudPrinterApiKey"] = cloudPrinterApiKey;
  }

  function populateObject(bean) {
    console.log(bean);
    setCloudPrinterApiKey(bean.cloudPrinterApiKey);
    setCloudPrinterUrl(bean.cloudPrinterUrl);
  }

  return (
    <PSettingsCard
      avatar="C"
      title={translate("Cloud Printer API")}
      cardContent={content}
      onValidate={validate}
      createPayload={createPayload}
      populateObject={populateObject}
      messagHandler={props.messagHandler}
      settingKey="store_cloud_print"
      ignoreLoadError={true}
    ></PSettingsCard>
  );
}
